// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/icomoon.eot?rm5052", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/icomoon.ttf?rm5052", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/icomoon.woff?rm5052", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/icomoon.svg?rm5052", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=contact-icon-],
[class*=contact-icon-] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.contact-icon-email:before {
  content: "\\e100";
  color: #142e54;
}

.contact-icon-instagram:before {
  content: "\\e101";
  color: #142e54;
}

.contact-icon-tiktok:before {
  content: "\\e102";
  color: #142e54;
}

.contact-icon-facebook:before {
  content: "\\e103";
  color: #142e54;
}

.contact-icon-youtube:before {
  content: "\\e104";
  color: #142e54;
}

.contact-icon-x:before {
  content: "\\e105";
  color: #142e54;
}

.contact-icon-linkedin:before {
  content: "\\e106";
  color: #142e54;
}`, "",{"version":3,"sources":["webpack://./src/assets/icons/contact/style.css"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,4CAAA;EACA,mPACI;EAIJ,mBAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAMA;;EAEI,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AALJ;;AAQA;EACI,gBAAA;EACA,cAAA;AALJ;;AAOA;EACI,gBAAA;EACA,cAAA;AAJJ;;AAMA;EACI,gBAAA;EACA,cAAA;AAHJ;;AAKA;EACI,gBAAA;EACA,cAAA;AAFJ;;AAIA;EACI,gBAAA;EACA,cAAA;AADJ;;AAGA;EACI,gBAAA;EACA,cAAA;AAAJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ","sourcesContent":["@font-face {\n    font-family: 'icomoon';\n    src: url('fonts/icomoon.eot?rm5052');\n    src:\n        url('fonts/icomoon.eot?rm5052#iefix') format('embedded-opentype'),\n        url('fonts/icomoon.ttf?rm5052') format('truetype'),\n        url('fonts/icomoon.woff?rm5052') format('woff'),\n        url('fonts/icomoon.svg?rm5052#icomoon') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n}\n\n[class^='contact-icon-'],\n[class*='contact-icon-'] {\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: 'icomoon' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.contact-icon-email:before {\n    content: '\\e100';\n    color: #142e54;\n}\n.contact-icon-instagram:before {\n    content: '\\e101';\n    color: #142e54;\n}\n.contact-icon-tiktok:before {\n    content: '\\e102';\n    color: #142e54;\n}\n.contact-icon-facebook:before {\n    content: '\\e103';\n    color: #142e54;\n}\n.contact-icon-youtube:before {\n    content: '\\e104';\n    color: #142e54;\n}\n.contact-icon-x:before {\n    content: '\\e105';\n    color: #142e54;\n}\n.contact-icon-linkedin:before {\n    content: '\\e106';\n    color: #142e54;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
